import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"

export type User = {
  puzzelUserId: string
  firstName: string
  lastName: string
  solutionCustomerId: string
  solutionUid: string
  userUid: string
  role: string
  expiry: Date
  solutions: {
    uid: string
    name: string
    userUid: string
  }[]
}

export type AuthedUser = User & { hasSuperpowers: boolean }

export const SUPERPOWER_ROLES = new Set(["SysAdmin", "Partner"])

export const meQuery = queryOptions({
  queryKey: ["me"] as const,
  queryFn: async (): Promise<AuthedUser> => {
    const user = await request.get<User>("/auth/user")
    return {
      ...user,
      hasSuperpowers: SUPERPOWER_ROLES.has(user.role),
    }
  },
})
